import { rootStore } from '../store/Root.store'
import { getUrlParam } from './urlParams'

export const forceRedirect = (redirectUrl: string) => {
  rootStore.TrackingState.setShouldKeepAlive(false)
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.href = redirectUrl
}

// Like forceRedirect, but the current page is replaced in the history instead of kept behind the
// target: for leaving a page the user must not be able to come back to.
export const forceReplace = (redirectUrl: string) => {
  rootStore.TrackingState.setShouldKeepAlive(false)
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.replace(redirectUrl)
}

export const forceReload = () => {
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.reload()
}

export const addSearchParamsAndReload = (params: Record<string, string>) => {
  const url = new URL(window.location.href)

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  if (window.location.href === url.toString()) {
    window.location.reload()
  } else {
    window.location.href = url.toString()
  }
}

// Appends the theme and language of the current page to an in-app path, so a page reached by a full
// redirect (error pages, return pages) keeps the same look and copy. Both are read from the current URL,
// which is where the backend put them, with the store's current values as fallback.
export const withCommonQueryParams = (path: string): string => {
  const url = new URL(path, window.location.origin)

  if (!url.searchParams.has('themeId')) {
    url.searchParams.set('themeId', getUrlParam('themeId') ?? rootStore.InterfaceState.themeId)
  }
  if (!url.searchParams.has('language')) {
    url.searchParams.set(
      'language',
      getUrlParam('language') ?? rootStore.TranslationsState.language
    )
  }

  return `${url.pathname}${url.search}`
}
